import request from '../request'

/**
 * 获取项目备案列表
 * @param {Object} params 查询参数（分页、筛选等）
 */
export function getProjectFilingList(params) {
    return request({
        url: '/market-service/scrm/project/filing/list',
        method: 'GET',
        params,
    })
}

/**
 * 新增项目备案
 * @param {Object} data 表单数据
 */
export function addProjectFiling(data) {
    return request({
        url: '/market-service/scrm/project/filing/add',
        method: 'POST',
        data,
    })
}

/**
 * 修改项目备案
 * @param {Object} data 表单数据
 */
export function updateProjectFiling(data) {
    return request({
        url: '/market-service/scrm/project/filing/update',
        method: 'POST',
        data,
    })
}
/**
 * 修改项目备案
 * @param {Object} data 表单数据
 */
export function resubmitProjectFiling(data) {
    return request({
        url: '/market-service/scrm/project/filing/resubmit',
        method: 'POST',
        data,
    })
}

/**
 * 删除项目备案
 * @param {number|string} id 备案ID
 */
export function deleteProjectFiling(id) {
    return request({
        url: `/market-service/scrm/project/filing/delete/${id}`,
        method: 'POST',
    })
}

/**
 * 获取项目备案详情
 * @param {number|string} id 备案ID
 */
export function getProjectFilingDetail(id) {
    return request({
        url: `/market-service/scrm/project/filing/query/${id}`,
        method: 'GET',
    })
}

/**
 * 关闭项目备案
 * @param {number|string} id 备案ID
 * @param {string} closeReason 关闭原因
 */
export function closeProjectFiling(id, closeReason) {
    return request({
        url: `/market-service/scrm/project/filing/close/${id}`,
        method: 'POST',
        params: { closeReason },
    })
}

/**
 * 将项目备案转换为正式项目
 * @param {number|string} id 备案ID
 */
export function convertProjectFiling(id) {
    return request({
        url: `/market-service/scrm/project/filing/convert/${id}`,
        method: 'POST',
    })
}

/**
 * 分配项目备案负责人
 * @param {Object} data { ids, newChargeUserId, newChargeUserName }
 */
export function assignProjectFiling(data) {
    return request({
        url: '/market-service/scrm/project/filing/assign',
        method: 'POST',
        data,
    })
}

/**
 * 获取大客户列表
 * @param {Object} params 查询参数
 */
export function getMajorClientList(params) {
    return request({
        url: '/project-service/area/getMajorClientList',
        method: 'GET',
        params,
    })
}

/**
 * 获取区域负责人
 * @param {Object} params { cityName, districtName }
 */
export function getAreaCharger(params) {
    return request({
        url: '/project-service/area/getAreaCharger',
        method: 'GET',
        params,
    })
}
